/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterTenantDto as PlatformRegisterTenantDto } from '../../models/platform/register-tenant-dto';
import { RegistrationResultDto as PlatformRegistrationResultDto } from '../../models/platform/registration-result-dto';

export interface RegisterTenant$Params {
      body: PlatformRegisterTenantDto
}

export function registerTenant(http: HttpClient, rootUrl: string, params: RegisterTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformRegistrationResultDto>> {
  const rb = new RequestBuilder(rootUrl, registerTenant.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformRegistrationResultDto>;
    })
  );
}

registerTenant.PATH = '/tenant/register';

